<script lang="ts">
  let {
    dates = [],
    selected = $bindable(null as string | null),
    format = "short",
    class: cls = "",
  }: {
    dates?: string[];
    selected?: string | null;
    format?: "short" | "long";
    class?: string;
  } = $props();

  function formatDay(dateStr: string): string {
    const d = new Date(dateStr);
    if (format === "long") {
      return d.toLocaleDateString("ko-KR", { month: "long", day: "numeric", weekday: "long" });
    }
    return d.toLocaleDateString("ko-KR", { month: "numeric", day: "numeric" });
  }

  function getDow(dateStr: string): string {
    return new Date(dateStr).toLocaleDateString("ko-KR", { weekday: "short" });
  }
</script>

<div class="flex gap-2 overflow-x-auto pb-1 {cls}" role="tablist">
  {#each dates as date, i}
    <button
      type="button"
      role="tab"
      aria-selected={selected === date}
      class="shrink-0 flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl border transition-colors text-center
        {selected === date
          ? 'bg-teal-400/15 border-teal-400 text-teal-400'
          : 'bg-white/5 border-white/10 text-gray-400 hover:border-white/20 hover:text-gray-300'}"
      onclick={() => (selected = date)}
    >
      <span class="text-xs">{getDow(date)}</span>
      <span class="text-sm font-semibold">{formatDay(date)}</span>
      <span class="text-[10px] opacity-60">Day {i + 1}</span>
    </button>
  {/each}
</div>
